<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-lamp-alt`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M37.147 2.824A1 1 0 0036.163 2H11.837a1 1 0 00-.984.824l-4.643 26A1 1 0 007.194 30H22v12H15a1 1 0 00-1 1v2a1 1 0 001 1h18a1 1 0 001-1v-2a1 1 0 00-1-1h-7V30h4v6a1 1 0 001 1h2a1 1 0 001-1v-6h6.806a1 1 0 00.984-1.176l-4.643-26zM14.35 6h19.302l3.571 20H10.778l3.571-20z"/></svg>
</template>
<script>

export default {
  name: 'IconLampAlt',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
